import React from 'react';
import { Search, X } from 'lucide-react';

export interface TableTextSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  'aria-label'?: string;
}

/**
 * Campo de búsqueda reutilizable (estilos globales en styles/modals.css).
 */
const TableTextSearch: React.FC<TableTextSearchProps> = ({
  value,
  onChange,
  placeholder,
  'aria-label': ariaLabel,
}) => {
  return (
    <div className="costcenter-search">
      <div className="search-input-wrapper">
        <Search className="search-icon" size={18} aria-hidden />
        <input
          type="search"
          className="search-input-field"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label={ariaLabel ?? placeholder}
        />
        {value ? (
          <button
            type="button"
            className="search-clear-btn"
            onClick={() => onChange('')}
            aria-label="Limpiar búsqueda"
          >
            <X size={16} />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default TableTextSearch;
